<template>
    <PopOut :narrow="false" :open="open" :show-close-icon="true" @close="dismissModal" :is-card="true" :close-has-background="true" :formType="formType">
        <div class="create-account-modal__container">
            <div class="create-account-modal__bg" :class="image">
                <img class="create-account-modal__logo" v-if="formType !== 'valuation'" src="/images/my-account/my-account-icon.svg" alt="" />
            </div>
            <div class="create-account-modal__body">
                <div class="create-account-modal__body-item">
                    <p v-html="text" class="create-account-modal__body-text"></p>
                    <!-- <p class="create-account-modal__body-text">
                        Set notifications for your service and MOT due times and keep track of your vehicles value.
                    </p> -->
                </div>
            </div>
        </div>
    </PopOut>
</template>

<script>
import PopOut from "./PopOut.vue";

export default {
    components: {
        PopOut,
    },
    props: {
        open: {
            type: Boolean,
            default: false,
        },
        formType: {
            type: String,
            default: 'osb',
        },
    },

    data() {
        return {
            loading: false,
        };
    },

    computed: {
        text() {
            if (this.formType === "valuation") {
                return "Create an account to store and keep track of your vehicles valuation in a personalised space. You can also set notifications for your service and MOT due times and save your favourite vehicles and configurations."
            }
            if (this.formType === "osb") {
                return `Create an account to store your vehicles servicing information all in one place. <br />
                Set notifications for your service and MOT due times and keep track of your vehicles value.`
            }
            if (this.formType === "reservation") {
                return `Keep your enquiries organised and easily accessible in your own personalised space by creating an account today.`
            }
        },
        image() {
            if (this.formType === "valuation") {
                return "create-account-modal__valuation-image"
            }
            if (this.formType === "osb") {
                return "create-account-modal__osb-image"
            }
            if (this.formType === "reservation") {
                return "create-account-modal__reservation-image"
            }
        }
    },

    methods: {
        dismissModal() {
            this.$emit('closeModal', true)
        },
    },
};
</script>

<style lang="scss" scoped>
.modal {
    &__container {
        max-width: 400px;
    }

    &__inner {
        padding: 0px
    }
}
</style>
